import './style.css';
import Application from './Application/Application';
import { runIntro } from './Intro/Intro';
// L'intro est lancee AVANT la construction de l'Application, et celle-ci est
// isolee dans un try/catch.
//
// Dans l'ordre inverse (`new Application()` puis `runIntro()`), la moindre
// exception du constructeur empechait runIntro() d'etre appele : le visiteur
// ne voyait alors qu'un ecran navy vide, sans le splash. C'est un risque
// surtout sur mobile, ou le contexte WebGL peut etre refuse par manque de
// memoire. Le splash ne depend de rien et doit jouer quoi qu'il arrive.
runIntro(() => {
    // L'Application a charge derriere l'overlay pendant toute l'intro.
});
try {
    new Application();
}
catch (error) {
    // Relance en asynchrone, et non un console.error : webpack.prod.js active
    // drop_console, qui effacerait la trace en production et rendrait un
    // echec de la scene totalement invisible. Rejetee depuis un setTimeout,
    // l'erreur remonte en erreur non capturee (console du navigateur,
    // window.onerror) sans empecher l'intro, deja lancee, d'aller au bout.
    setTimeout(() => {
        throw error;
    }, 0);
}
